import { Helmet } from "react-helmet";

function HomePage() {
  return (
    <>
      <Helmet>
        <title>Vivea | Timeless Blooms & Bespoke Bouquets in Iligan City</title>
        <meta
          name="description"
          content="With our modern, simple, and thoughtful approach, Vivea Bloom makes it easy to send love, gratitude, or celebration through carefully curated bouquets that speak with beauty and intention."
        />

        <meta
          property="og:title"
          content="Fresh. Minimal. Meaningful. That’s Vivea Bloom."
        />
        <meta
          property="og:description"
          content="With our modern, simple, and thoughtful approach, Vivea Bloom makes it easy to send love, gratitude, or celebration through carefully curated bouquets that speak with beauty and intention."
        />
        <meta property="og:url" content="https://viveabloom.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ik.imagekit.io/cwulowfy7/logo.png?updatedAt=1762873922611"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Paculba Flower Shop Iligan City" />
        <meta
          name="twitter:description"
          content="Fresh. Minimal. Meaningful. That’s Vivea Bloom."
        />
        <meta
          name="twitter:image"
          content="https://ik.imagekit.io/cwulowfy7/logo.png?updatedAt=1762873922611"
        />
      </Helmet>
    </>
  );
}

export default HomePage;
